import { useNavigate, useLocation } from "react-router-dom";
import { UrlHelper } from "utils/helpers";

function useCreateWeeklyTimeReport() {
  const location = useLocation();
  const navigate = useNavigate();

  return async function createWeeklyTimeReport() {
    navigate(UrlHelper.formatPath(`/TimeReport/Weekly`), {
      state: { background: location },
    });
    return;
  };
}

export default useCreateWeeklyTimeReport;
